import _extends from "@babel/runtime/helpers/esm/extends";
import { generateUtilityClasses, generateUtilityClass } from '@mui/base';
import { inputBaseClasses } from '../InputBase';
export function getFilledInputUtilityClass(slot) {
  return generateUtilityClass('MuiFilledInput', slot);
}

const filledInputClasses = _extends({}, inputBaseClasses, generateUtilityClasses('MuiFilledInput', ['root', 'underline', 'input']));

export default filledInputClasses;